import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginActive:sessionStorage.getItem("token")?true:false,
    mySwiperIndex:0,
    setMySwiperActive:false,
  },
  getters: {
  },
  mutations: {
    setLoginActive(state, data){
      state.loginActive = data
    },
    setMySwiperIndex(state,data){
      state.mySwiperIndex = data
    },
    setMySwiperActive(state,data){
      console.log(data,'mutations')
      state.setMySwiperActive = data
    }
  },
  actions: {
  },
  modules: {
  }
})
